import { createSlice } from '@reduxjs/toolkit';
import { ActiveAccount } from '../../types/interfaces/account.interfaces';
import { getLocalActiveAccountId } from '../../utils/localStorageHandler';

const initialState: ActiveAccount = {
  accountId: getLocalActiveAccountId(),
  name: '',
  billingEnabled: true,
  locked: false,
  contactFirstName: '',
  contactLastName: '',
  contactEmail: '',
  contactPhone: '',
  timezoneInfo: '',
  users: [],
  attributes: {
    AccountStoragePlan: undefined,
  },
  addresses: [],
  owner: {
    userId: 0,
    username: '',
    firstName: '',
    lastName: '',
    contactPhone: '',
    verified: false,
    roles: [],
    scopes: [],
    accounts: [],
    tenantId: '',
    timezoneInfo: '',
    addresses: [],
    enabled: false,
    profileImageId: '',
  },
};

export const activeAccountSlice = createSlice({
  name: 'activeAccount',
  initialState,
  reducers: {
    storeActiveAccount: (state, action) => {
      state.accountId = action.payload.accountId;
      state.name = action.payload.name;
      state.billingEnabled = action.payload.billingEnabled;
      state.locked = action.payload.locked;
      state.contactFirstName = action.payload.contactFirstName;
      state.contactLastName = action.payload.contactLastName;
      state.contactEmail = action.payload.contactEmail;
      state.contactPhone = action.payload.contactPhone;
      state.timezoneInfo = action.payload.timezoneInfo;
      state.addresses = action.payload.addresses;
      state.owner = action.payload.owner;
      state.users = action.payload.users;
      state.attributes = action.payload.attributes;
    },
    clearActiveAccount: () => {
      return { ...initialState, accountId: getLocalActiveAccountId() };
    },
  },
});

export const { storeActiveAccount, clearActiveAccount } = activeAccountSlice.actions;

export default activeAccountSlice.reducer;
